import classNames from "classnames";
import Styles from "./News.module.scss";
import Footer from "../../Component/Footer/Footer";
import Navbar from "../../Component/Navbar/Navbar";
import SubTitle from "../../Component/Text/SubTitle";
import Card3 from "../../Component/Card/Card3";
import Button from "../../Component/Button/Button";

import news1 from "../../assets/images/index/news/照服員培訓.jpg";
import news2 from "../../assets/images/index/最新消息_1_2025_02_16.jpg";

import logo from "../../assets/images/logo/LOGO.png";
import news4 from "../../assets/images/index/news/20250513.jpg";
import news5 from "../../assets/images/index/news/用心守護每一程.jpg";
import React, { useEffect } from "react";
import { getNewsAll } from "../BGService/kbAPI";

const News = () => {
  const [news, setNews] = React.useState();
  // const news = [
  //   {
  //     id: 5,
  //     img: news5,
  //     title: "用心守護每一程",
  //     date: `2025-05-22`,
  //     to: `/news/5`,
  //   },
  //   {
  //     id: 4,
  //     img: news4,
  //     title: "花蓮縣身心障礙者臨時及短期服務",
  //     date: `2025-05-13`,
  //     to: `/news/4`,
  //   },
  //   {
  //     id: 3,
  //     img: logo,
  //     title: "花蓮實體課程開班通知",
  //     date: `2025-05-09`,
  //     to: `https://www.facebook.com/share/p/18WiMP4DDo/`,
  //   },
  //   {
  //     id: 2,
  //     img: news1,
  //     title: "照顧服務員資格訓練班 熱烈招生中！",
  //     date: `2025-02-14`,
  //     to: `https://www.facebook.com/share/p/16Uy7e6cMf/`,
  //   },
  //   {
  //     id: 1,
  //     img: news2,
  //     title: "生命最後的旅程 值得被溫柔對待",
  //     date: `2025-02-16`,
  //     to: `https://www.facebook.com/share/p/19Xipe13ws/`,
  //   },

  //   // { id: 3, img: `s`, title: "564651654", date: `2025-01-01` },
  //   // {
  //   //   id: 4,
  //   //   img: `s`,
  //   //   title: "564651654",
  //   //   date: `2025-01-01`,
  //   // },
  //   // {
  //   //   id: 5,
  //   //   img: `s`,
  //   //   title: "564651654",
  //   //   date: `2025-01-01`,
  //   // },
  // ];

  /**
   * Async Function
   */

  async function fetchAll() {
    const response = await getNewsAll();
    if (response.status === 50004) {
    } else if (response.status !== 200) {
      // navigate(`/payment_temp`);
    } else {
      setNews(response.data);
    }
  }

  /**
   * useEffect
   */
  useEffect(() => {
    fetchAll();
  }, []);

  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = React.useState(1);

  // 計算總頁數
  const totalPages = Math.ceil(news?.length / itemsPerPage);

  // 取得當前頁面顯示的資料
  const currentNews = news?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePrev = () => {
    setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setCurrentPage((prev) => (prev < totalPages ? prev + 1 : prev));
  };

  return (
    <div>
      <Navbar />
      <div
        className={classNames("container")}
        style={{ paddingTop: "8vh", minHeight: "60vh" }}
      >
        <SubTitle text={`最新消息`} />
        <div className={classNames(Styles.news__content)}>
          <div className={classNames(Styles.news__card)}>
            {currentNews?.map((data) => (
              <div className={classNames("mb-4")} key={data.id}>
                <a href={data.to} target="__blank" rel="noopener noreferrer">
                  <Card3 img={data.img} title={data.title} date={data.date} />
                </a>
              </div>
            ))}
          </div>
        </div>
        <div className={classNames(Styles.news__pagetation)}>
          <Button
            text={"<"}
            className={"primary"}
            onClick={handlePrev}
            disable={currentPage === 1}
          ></Button>

          <span className={classNames(Styles.news__pagetation__pageIndex)}>
            {currentPage} / {totalPages}
          </span>

          <Button
            text={">"}
            className={"primary"}
            onClick={handleNext}
            disable={currentPage === totalPages}
          ></Button>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};
export default News;
